/** Known legacy localStorage keys to delete once after cutover (quota reclaim). */
export const LEGACY_LOCAL_STORAGE_KEYS = [
	'chatty-tanstack-query-cache',
	'tanstack-query-cache',
	'saved-forms',
	'auth',
	'demo',
	'device_id',
	'ic-theme',
	'apexx.chat.videoMuted',
	'apexx.lastUpdateCheckTimestamp',
	'hub-text-size',
	// Common form-draft keys from useFormRemember
	'client-add-form',
	'series-add-form',
	'service-add-form',
	'product-add-form',
	'custom-notification-add-form',
] as const;

const CLEANUP_FLAG_KEY = 'apexx.storage.legacyLocalStorageCleanup.v1';

/**
 * Best-effort one-time removal of known legacy localStorage keys.
 * Safe to call on every boot; no-ops after the first successful run.
 */
export function cleanupLegacyLocalStorageKeys(
	extraKeys: readonly string[] = [],
	storage: Storage | null = typeof localStorage !== 'undefined' ? localStorage : null,
): void {
	if (!storage) {
		return;
	}

	try {
		if (storage.getItem(CLEANUP_FLAG_KEY) === '1') {
			return;
		}

		const keys = new Set<string>([...LEGACY_LOCAL_STORAGE_KEYS, ...extraKeys]);
		for (let i = 0; i < storage.length; i++) {
			const key = storage.key(i);
			if (!key) {
				continue;
			}
			if (key.startsWith('location-add-form-') || key.startsWith('unit-add-form-')) {
				keys.add(key);
			}
		}

		for (const key of keys) {
			try {
				storage.removeItem(key);
			} catch {
				// Ignore per-key failures.
			}
		}

		storage.setItem(CLEANUP_FLAG_KEY, '1');
	} catch {
		// Ignore private-mode / quota failures.
	}
}
